<div class="row">
  <div class="col-sm-12">
    <span class="form-control-label">AI assistant (Claude)</span>
    <p class="text-muted mb-2">
      Lets Claude create draft quotes from client emails on your behalf, with
      your rates. Drafts are never sent automatically.
    </p>
  </div>
</div>

@if (url(); as connectorUrl) {
  <div class="row m-t-10">
    <div class="col-sm-12">
      <span class="form-control-label">Connector URL</span>
      <div class="d-flex gap-2">
        <input
          pInputText
          class="form-control"
          type="text"
          readonly
          [value]="connectorUrl"
          (focus)="$any($event.target).select()"
        />
        <button pButton type="button" severity="secondary" (click)="copyUrl()">
          Copy
        </button>
      </div>
      <p class="text-muted mt-2 mb-0">
        This URL is your key: it is shown only now and anyone holding it can act
        as you. In Claude open
        <strong>Settings → Connectors → Add custom connector</strong>, paste it
        as the URL and save. If it leaks, click Connect again to replace it.
      </p>
    </div>
  </div>
} @else if (connected()) {
  <div class="row m-t-10">
    <div class="col-sm-12">
      <p class="mb-0">
        Connected
        @if (createdAt(); as since) {
          since {{ since | date: "medium" }}
        }
        . The URL was shown when it was issued; connect again for a new one.
      </p>
    </div>
  </div>
}

<div class="row m-t-10">
  <div class="col-sm-12">
    <button
      pButton
      type="button"
      severity="success"
      (click)="connect()"
      [disabled]="loading()"
    >
      @if (loading()) {
        <i class="pi pi-spinner"></i>
      }
      {{ connected() ? "Connect again" : "Connect" }}
    </button>
    @if (connected()) {
      <button
        pButton
        type="button"
        severity="danger"
        class="ms-2"
        (click)="disconnect()"
        [disabled]="loading()"
      >
        Disconnect
      </button>
    }
  </div>
</div>
